module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }